import { Col, Row, Typography } from "antd";
import moment from "moment";
import React from "react";

const { Text } = Typography;
const IncomeStaffIncomeList = ({ record, userList }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const renderStaffList = () => {
    const staffs = record?.staffs || [];
    return staffs.map((staff, index) => {
      const [staffInfo] =
        userList?.filter((user) => user?.id === staff?.userId) || [];
      const staffName = staffInfo
        ? `${staffInfo?.firstName} ${staffInfo?.lastName}`
        : "No name";
      return (
        <Col span={24} key={index}>
          <Row gutter={[5, 5]} justify="space-between">
            <Col>
              <Text>{`${index + 1}. ${staffName}`}</Text>
            </Col>
            <Col align="right">
              <Text>{`$${staff?.value}`}</Text>
            </Col>
          </Row>
        </Col>
      );
    });
  };
  // -------------------------- MAIN --------------------------
  if (record) {
    return (
      <Col span={24}>
        <Row justify={[20, 20]}>
          <Col span={6}>Staffs: </Col>
          <Col span={18}>{renderStaffList()}</Col>
        </Row>
      </Col>
    );
  }
  return null;
};
export default IncomeStaffIncomeList;
